import { provideState } from '@ngrx/store';

import { billsharkInfoFeature } from './billshark-info.reducer';

export const billsharkInfoStore = [provideState(billsharkInfoFeature)];
